import { render, staticRenderFns } from "./FeedbackChatboxMessage.vue?vue&type=template&id=996df502&scoped=true&"
import script from "./FeedbackChatboxMessage.vue?vue&type=script&lang=js&"
export * from "./FeedbackChatboxMessage.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackChatboxMessage.vue?vue&type=style&index=0&id=996df502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996df502",
  null
  
)

export default component.exports